import React from 'react'
import StyledMdText from '../../../common/components/styledMdText/StyledMdText'
import { Link } from 'react-router-dom'
import MobileHeader from '../mobileHeader/MobileHeader'
import { CustomConnectButton } from '../../customConnectButton/CustomConnectButton'
import { content } from '../../../data'
import { useAccount } from 'wagmi'

const Header = () => {

  const menuItems = content?.menuItems;
  const account = useAccount()

  return (
    <div className='absolute top-0 z-10 flex flex-col items-center w-full bg-black border border-b-white border-opacity-20'>
      <div className='w-[90%] py-2.5 flex items-center justify-between'>
        <Link to="/" className='flex gap-3 cursor-pointer w-[50%] md:w-[30%] justify-start'>
          <div>
            <img width={60} height={60} src='/assets/images/logo.webp' alt='Logo' />
          </div>
          <div className='items-center hidden md:flex'>
            <StyledMdText fontColor="text-gradient">HopeLedger</StyledMdText>
          </div>
        </Link>
        <div className='hidden md:flex gap-10 md:w-[40%] justify-center'>
          {
            menuItems?.map((item, index) => (
              <Link to={item?.link} key={index} className='text-white'>{item?.menu}</Link>
            ))
          }
        </div>
        <div className='flex gap-5 w-[50%] md:w-[30%] justify-end'>
          <div className='hidden w-[50%] md:block'>
            <CustomConnectButton variant="button-gradient" />
          </div>
          {account?.isConnected && (
            <Link to="/profile" className='flex items-center justify-center text-white'>
              <img width={30} height={30} className='duration-500 rounded-full hover:scale-105' src='/assets/images/placeholder.png' alt='Profile' />
            </Link>
          )}
          <div className='flex items-center'>
            <MobileHeader />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
